import { cn } from "../ui/cn";
import {
  TAB_ORDER,
  INTEGRATIONS,
  type IntegrationName,
} from "../data/integrations";

export function IntegrationTabs({
  current,
  onSelect,
}: {
  current: IntegrationName;
  onSelect: (name: IntegrationName) => void;
}) {
  return (
    <div className="mt-12 flex border-b border-dashed border-dash-d overflow-x-auto -mb-px">
      {TAB_ORDER.map((name) => {
        const integration = INTEGRATIONS[name];
        const active = name === current;
        const disabled = integration.soon;
        return (
          <button
            key={name}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(name)}
            className={cn(
              "px-4.5 py-3 font-mono text-xs uppercase tracking-wider whitespace-nowrap",
              "flex items-center gap-2 border-b-2 -mb-px",
              disabled && "cursor-not-allowed text-td-3",
              !disabled && !active && "text-td-2 cursor-pointer hover:text-td-1",
              active
                ? "text-accent border-accent"
                : "border-transparent",
            )}
          >
            {name}
            {integration.soon && (
              <span className="text-[9px] text-warn border border-dashed border-warn rounded-full px-1.5 py-px">
                SOON
              </span>
            )}
            {integration.locked && (
              <span className="text-[9px] text-good">●</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
